import { createMemo } from "solid-js";
import type { TeamsCardProps, membersProps } from "../_model";
import { request } from "../apis";
import { global } from ":shared/app";
import { Button } from ":ui/form";
import { ImagesStacked } from "../../SHARED/components";

export default function TeamsCard(props: TeamsCardProps) {
  const $status = createMemo(() => {
    const status = props?.status.toLowerCase();
    return {
      value: props.status,
      complete: status === "complete",
      incomplete: status === "in-complete",
    };
  });
  async function onSendInvite() {
    const requester_email = global.api.auth.events.getUserEmail();
    const email = props?.members?.find((member: membersProps) => member?.role === "leader")?.email;
    const data = {
      requester_email: requester_email,
      receiver_email: email,
      status: "pending",
    };
    return await request.post(JSON.stringify(data)).then(() => {
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Invite Sent",
      });
    });
  }

  return (
    <div class="flex flex-col min-w-full h-200px bg-bg rounded-xl  px-3 py-2 border-1 border-solid border-border-card <sm:(h-150px)">
      {/* status and track */}
      <div class="flex flex-row justify-between items-center">
        <p class="flex flex-row text-14px items-center gap-x-1">
          <span class={"w-9px h-9px rounded-full" + " " + ($status().complete ? "bg-success" : "bg-warn")} />
          <span
            class={
              //
              "" + " " + ($status().complete ? "text-success" : "text-warn")
            }
          >
            {props?.status ?? "No status"}
          </span>
        </p>
        <p class="bg-warn-shade text-warn text-13px py-1 px-2 capitalize rounded-md">{props?.track ?? "No track"}</p>
      </div>
      {/* team name */}
      <p class="h-40px font-bold text-16px py-1 <sm:py-0">{props?.team_name ?? "No team name"}</p>
      {/* images */}
      <div class="flex items-center justify-between mt-2">
        <ImagesStacked items={props.members} />

        <Button
          //
          controls={{}}
          // class={"form-btn !mt-1 " + " " + (props.team != undefined ? "disabled:(!bg-error-shade text-error)" : "")}
          class={"form-btn !w-135px whitespace-nowrap !self-end" + " "}
          // triggers={{
          //   manualStatus: props.team == undefined ? "valid" : "invalid",
          // }}
          onSubmit={(e) => {
            return onSendInvite();
          }}
          // statusInvalid={"Part Of Team " + String(props.team)}
          statusValid={"Send Request"}
        />
      </div>
    </div>
  );
}
